import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import Addproductview from "./Addproductview";

function NewJournalEntry() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>New Product View</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <Addproductview />
      </div>
    </div>
  );
}

export default NewJournalEntry;